import "xe-utils";
import XEUtils from 'xe-utils'
import VXETable from 'vxe-table'
import comm from '../store/common'
// import PublicFunction from "../utils/PublicFunction.js";

// const { toFixed } = PublicFunction;

// VXETable 格式化数据
// 数字类型
VXETable.formats.add('price', ({ cellValue }, digits = comm.sys_param['price_dec']) => {
  let ret_val = '';
  if (comm.sys_param['is_show_zero'] == 1) { // 是否显示为0的数据
    ret_val = XEUtils.commafy(XEUtils.toNumber(cellValue), { digits })
  } else {
    ret_val = cellValue ? XEUtils.commafy(XEUtils.toNumber(cellValue), { digits }) : ''
  }
  return ret_val
})
VXETable.formats.add('quantity', ({ cellValue }, digits = comm.sys_param['quantity_dec']) => {
  let ret_val = '';
  if (comm.sys_param['is_show_zero'] == 1) {
    ret_val = XEUtils.commafy(XEUtils.toNumber(cellValue), { digits })
  } else {
    ret_val = cellValue ? XEUtils.commafy(XEUtils.toNumber(cellValue), { digits }) : ''
  }
  return ret_val
})
VXETable.formats.add('amount', ({ cellValue }, digits = comm.sys_param['amount_dec']) => {
  let ret_val = '';
  if (comm.sys_param['is_show_zero'] == 1) {
    ret_val = XEUtils.commafy(XEUtils.toNumber(cellValue), { digits })
  } else {
    ret_val = cellValue ? XEUtils.commafy(XEUtils.toNumber(cellValue), { digits }) : ''
  }
  return ret_val
})
VXETable.formats.add('cost', ({ cellValue }, digits = comm.sys_param['cost_dec']) => {
  let ret_val = '';
  if (comm.sys_param['is_show_zero'] == 1) {
    ret_val = XEUtils.commafy(XEUtils.toNumber(cellValue), { digits })
  } else {
    ret_val = cellValue ? XEUtils.commafy(XEUtils.toNumber(cellValue), { digits }) : ''
  }
  return ret_val
})
VXETable.formats.add('profit', ({ cellValue }, digits = comm.sys_param['profit_dec']) => {
  let ret_val = '';
  if (comm.sys_param['is_show_zero'] == 1) {
    ret_val = XEUtils.commafy(XEUtils.toNumber(cellValue), { digits })
  } else {
    ret_val = cellValue ? XEUtils.commafy(XEUtils.toNumber(cellValue), { digits }) : ''
  }
  return ret_val
})
VXETable.formats.add('int', ({ cellValue }, digits = 0) => {
  let ret_val = '';
  if (comm.sys_param['is_show_zero'] == 1) {
    ret_val = XEUtils.commafy(XEUtils.toNumber(cellValue), { digits })
  } else {
    ret_val = cellValue ? XEUtils.commafy(XEUtils.toNumber(cellValue), { digits }) : ''
  }
  return ret_val
})
VXETable.formats.add('dec1', ({ cellValue }, digits = 1) => {
  let ret_val = '';
  if (comm.sys_param['is_show_zero'] == 1) {
    ret_val = XEUtils.commafy(XEUtils.toNumber(cellValue), { digits })
  } else {
    ret_val = cellValue ? XEUtils.commafy(XEUtils.toNumber(cellValue), { digits }) : ''
  }
  return ret_val
})
VXETable.formats.add('dec2', ({ cellValue }, digits = 2) => {
  let ret_val = '';
  if (comm.sys_param['is_show_zero'] == 1) {
    ret_val = XEUtils.commafy(XEUtils.toNumber(cellValue), { digits })
  } else {
    ret_val = cellValue ? XEUtils.commafy(XEUtils.toNumber(cellValue), { digits }) : ''
  }
  return ret_val
})
VXETable.formats.add('dec3', ({ cellValue }, digits = 3) => {
  let ret_val = '';
  if (comm.sys_param['is_show_zero'] == 1) {
    ret_val = XEUtils.commafy(XEUtils.toNumber(cellValue), { digits })
  } else {
    ret_val = cellValue ? XEUtils.commafy(XEUtils.toNumber(cellValue), { digits }) : ''
  }
  return ret_val
})
VXETable.formats.add('dec4', ({ cellValue }, digits = 4) => {
  let ret_val = '';
  if (comm.sys_param['is_show_zero'] == 1) {
    ret_val = XEUtils.commafy(XEUtils.toNumber(cellValue), { digits })
  } else {
    ret_val = cellValue ? XEUtils.commafy(XEUtils.toNumber(cellValue), { digits }) : ''
  }
  return ret_val
})
VXETable.formats.add('dec5', ({ cellValue }, digits = 5) => {
  let ret_val = '';
  if (comm.sys_param['is_show_zero'] == 1) {
    ret_val = XEUtils.commafy(XEUtils.toNumber(cellValue), { digits })
  } else {
    ret_val = cellValue ? XEUtils.commafy(XEUtils.toNumber(cellValue), { digits }) : ''
  }
  return ret_val
})
VXETable.formats.add('percent_char', ({ cellValue }) => {
  return cellValue + '%';
})

// 日期时间类型
VXETable.formats.add('hour', ({ cellValue }, format = comm.sys_param['hour_format']) => {
  return cellValue ? XEUtils.toDateString(XEUtils.toStringDate(cellValue), format) : ''
})
VXETable.formats.add('hour_minute', ({ cellValue }, format = comm.sys_param['hour_minute_format']) => {
  return cellValue ? XEUtils.toDateString(XEUtils.toStringDate(cellValue), format) : ''
})
VXETable.formats.add('time', ({ cellValue }, format = comm.sys_param['time_format']) => {
  return cellValue ? XEUtils.toDateString(XEUtils.toStringDate(cellValue), format) : ''
})
VXETable.formats.add('year', ({ cellValue }, format = comm.sys_param['year_format']) => {
  return cellValue ? XEUtils.toDateString(XEUtils.toStringDate(cellValue), format) : ''
})
VXETable.formats.add('year_month', ({ cellValue }, format = comm.sys_param['year_month_format']) => {
  return cellValue ? XEUtils.toDateString(XEUtils.toStringDate(cellValue), format) : ''
})
VXETable.formats.add('date', ({ cellValue }, format = comm.sys_param['date_format']) => {
  return cellValue && cellValue != '0000-00-00' ? XEUtils.toDateString(XEUtils.toStringDate(cellValue), format) : ''
})
VXETable.formats.add('date_time', ({ cellValue }, format = comm.sys_param['date_time_format']) => {
  return cellValue ? XEUtils.toDateString(XEUtils.toStringDate(cellValue), format) : ''
})
VXETable.formats.add('date_hour_minute', ({ cellValue }, format = comm.sys_param['date_format'] + ' ' + comm.sys_param['hour_minute_format']) => {
  return cellValue ? XEUtils.toDateString(XEUtils.toStringDate(cellValue), format) : ''
})

// 打勾类型
VXETable.formats.add('check', ({ cellValue }) => {
  if ((cellValue == 1) || (cellValue == true)) {
    return '<img style="width: 19px" src="https://jilait.com/images/check.png" />';
  } else {
    return '<img style="width: 19px" src="https://jilait.com/images/delete.png" />';
  }
})
// 打勾类型，只显示勾，不显示叉
VXETable.formats.add('check_only', ({ cellValue }) => {
  if ((cellValue == 1) || (cellValue == true)) {
    return '<img style="width: 19px" src="https://jilait.com/images/check.png" />';
  } else {
    return '';
  }
})
// 打勾类型，只显示叉，不显示勾
VXETable.formats.add('check_only_delete', ({ cellValue }) => {
  if ((cellValue == 1) || (cellValue == true)) {
    return '<img style="width: 19px" src="https://jilait.com/images/delete.png" />';
  } else {
    return '';
  }
})
// 状态类型 1为正常，2为非正常
VXETable.formats.add('status', ({ cellValue }) => {
  if ((cellValue == 1) || (cellValue == true)) {
    return '<img style="width: 19px" src="https://jilait.com/images/idea.png" />';
  } else {
    return '<img style="width: 19px" src="https://jilait.com/images/noidea.png" />';
  }
})
// 图片
VXETable.formats.add('img', ({ cellValue }) => {
  return cellValue ? '<img style="width: 50px" src="' + cellValue + '" />' : '';
})

// VXETable.formats.add('show_img', ({ cellValue }) => {
//   return cellValue ? '<img style="width: 50px" src="' + cellValue + '" />' : '';
// })
// 1. 注册格式化处理（注意给 img 加上点击事件）
// VXETable.formats.add('show_img', ({ cellValue }) => {
//   if (!cellValue) return ''
//   return `<img 
//     src="${cellValue}" 
//     style="width: 36px; height: 36px; object-fit: cover; border-radius: 4px; cursor: pointer; vertical-align: middle;" 
//     onclick="window.vxeGlobalImgPreview(event, '${cellValue}')" 
//   />`
// })
// // 2. 挂载全局预览函数给 onclick 调用
// window.vxeGlobalImgPreview = (event, url) => {
//   event.stopPropagation() // 阻止点击图片时选中表格行
//   if (VXETable.previewImage) {
//     VXETable.previewImage({ urlList: [url] })
//   } else {
//     window.open(url, '_blank')
//   }
// }

// 自定义背景颜色 - 暂时用于用户组编辑表格
VXETable.formats.add('main_menu', ({ cellValue }) => {
  return '<span style="background-color: red">' + cellValue + '</span>';
})

VXETable.formats.add('sum_menu', ({ cellValue }) => {
  if (cellValue == 1) {
    return '<img style="width: 19px" src="https://jilait.com/images/check.png" />';
  } else {
    return '';
  }
})

// VXETable 格式化数据